import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';

import { QuoteChangeOrder } from "../../../interfaces/ChangeOrderBackendModel";

/*
 * GraphQL Query for fetching the quote change order.
 */
export const getQuoteChangeOrderQuery = gql`
  query quoteCOGetQuoteChangeOrder($changeOrderId: ID!) {
    quoteCOGetQuoteChangeOrder(changeOrderId: $changeOrderId) {
      quoteChangeOrder {
        id
        type
        rfqResponseId
        rfqRevision
        businessId
        description
        status
        poIds
        createdAt
        updatedAt
        updatedBy
        reasonForChange
        currency
        businessRequester
        category
        vendorId
        requesterEmail
        requesterUserId
        documents {
          inputFiles {
            name
            errorFile
            status
            createdAt
          }
          quoteFile {
            name
            errorFile
            status
            createdAt
          }
          additionalFiles {
            name
            errorFile
            status
            createdAt
          }
        }
        currentAssignee
        properties {
          name
          value
        }
        approvers {
          role
          approverGroup
          approverName
          approvalDate
        }
      }
    }
  }
`;

interface GetQuoteChangeOrderResponse {
  quoteCOGetQuoteChangeOrder: {
    quoteChangeOrder: QuoteChangeOrder;
  };
}

export async function getQuoteChangeOrder(
    client: ApolloClient<object>,
    changeOrderId: string
): Promise<QuoteChangeOrder> {
  try {
    const response = await client.query<GetQuoteChangeOrderResponse>({
      query: getQuoteChangeOrderQuery,
      variables: {
        changeOrderId
      },
      fetchPolicy: 'network-only'
    });

    return response.data.quoteCOGetQuoteChangeOrder.quoteChangeOrder;

  } catch (err) {
    throw new Error(`Unable to retrieve quote change order: ${err}`);
  }
}
